import React from "react"
import * as eventHighlightLeftImageStyles from "../../styles/landing_pages/EventHighlightLeftImage.module.css"
import { ChildSelector } from "../../helpers/ChildSelector"
import WPImage, { DISPLAY_MODE } from "../_base/WPImage"

export default function EventHighlightLeftImage({
  content,
  className,
  pageContext,
}) {
  const subtitle = ChildSelector.select(
    content,
    `highlight-left-subtitle`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )
  const text = ChildSelector.select(
    content,
    `highlight-left-text`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  return (
    <div
      className={`row ${className} ${eventHighlightLeftImageStyles.wrapper}`}
    >
      <div
        className={`col-12 col-lg-6 ${eventHighlightLeftImageStyles.mediaWrapper}`}
      >
        <div className={eventHighlightLeftImageStyles.imageWrapper}></div>
        <WPImage
          holder={content}
          selector="media-asset"
          mode={DISPLAY_MODE.normal}
          className={eventHighlightLeftImageStyles.image}
        />
      </div>
      <div
        className={`col-12 col-lg-6 ${eventHighlightLeftImageStyles.contentWrapper}`}
      >
        {subtitle && (
          <h4
            className={eventHighlightLeftImageStyles.subtitle}
            dangerouslySetInnerHTML={{ __html: subtitle }}
          />
        )}
        {text && (
          <p
            className={eventHighlightLeftImageStyles.text}
            dangerouslySetInnerHTML={{ __html: text }}
          />
        )}
      </div>
    </div>
  )
}
